import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-x4"
}

import BaseDialog from '@/shared/dialog/BaseDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketDeliverableDialog',
  props: {
    heading: { default: '' },
    isOpen: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {






const close = (): void => {
    emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": __props.isOpen,
    class: "py-40 pl-50 pr-30 mx-auto bg-white text-center relative z-1 w-screen-80 max-w-850",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "heading", {}, () => [
          _createVNode(_Transition, {
            name: "o-anim-fade-300",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("h2", { key: __props.heading }, _toDisplayString(__props.heading), 1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["o-scrollbar-y mt-40 mr-8 pr-20 max-h-screen-50", { 'max-h-screen-40': _ctx.$slots.navigation}])
        }, [
          _renderSlot(_ctx.$slots, "default", { close: close })
        ], 2),
        (_ctx.$slots.navigation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "navigation")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["is-open"]))
}
}

})